import React from "react";
import { Provider, connect } from "react-redux";
import BannerApp from "./bannerApp.cmpt";
import Ligas from "./ligas.cmpt";
import Header from "./header.cmpt";

const mapState = (state) => {
	return {
		conectaMovil: state.global.conectaMovil
	};
};

const styles = {
	"width": {
		"width": 1200
	}
};

export default class PortalLayout extends React.Component {

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro") || url.includes("#!/registro-familiar/") || url.includes("#!/registro-express") ) {
			main.style.maxHeight = "100%";
			main.style.paddingBottom = "30px";

			if (url.includes("#!/gnp/registro-reingenieria")) {
        		var header = document.getElementById("header-gnp-corporativo");
        		console.log("Header Portal", header);
        		if (header) {
          			header.style.display = "none";
          			console.log("Se oculta header en registro!!");
        		}

				var footer = document.getElementById('main-footer');
				if(footer){
					var child = footer.firstChild.childNodes;
					child.forEach(item => {
						if(item.className !== 'row icon-links'){
							console.log(item);
							item.style.display = 'none';
						}
					});
				}
      		}
		}
	}

	render() {
		var Modulo = this.props.modulo;
		var state = this.props.redux.getState();
		var mostrarBanner;
		const url = window.location.hash;

		if (url.includes("#!/gnp/registro") || url.includes("#!/gnp/registro-asistido") || url.includes("#!/registro-familiar") || url.includes("#!/recuperar-contrasenia")) {
			mostrarBanner = false;
		} else {
			mostrarBanner = true;
		}
		//Mostrar header
		var showHeader = url.includes("#!/gnp/registro-reingenieria");

		if (state.global.conectaMovil == true) {
			return (<Modulo redux={this.props.redux} hashOne={this.props.hashOne} hashTwo={this.props.hashTwo} hashThree={this.props.hashThree} email={this.props.email} />);
		} else {
			if (mostrarBanner === false) {
				return (
				<Provider store={this.props.redux}>
					<div className="flex layout-column layout-align-space-around-center">
						<div style={styles.width}>
							<div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
								<div className="main">
									{showHeader ? <Header /> : <div/>}
									<Modulo redux={this.props.redux} hashOne={this.props.hashOne} hashTwo={this.props.hashTwo} hashThree={this.props.hashThree} email={this.props.email} />
								</div>
							</div>
						</div>
					</div>
				</Provider>);
			} else {
				return (<Provider store={this.props.redux}>
					<div className="flex layout-column layout-align-space-around-center">
						<div style={styles.width}>
							<div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
								<div className="main">
									<Modulo redux={this.props.redux} hashOne={this.props.hashOne} hashTwo={this.props.hashTwo} hashThree={this.props.hashThree} email={this.props.email} />
								</div>
								<BannerApp />
								<div className="hide-md hide-sm hide-xs" >
									<Ligas />
								</div>
							</div>
							<div className="hide-gt-md layout-row layout-align-center-center">
								<Ligas />
							</div>
						</div>
					</div>
				</Provider>);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/home/portalLayout.cmpt.js